export const LinkWord = {
  textDecoration: "none",
  color: "#32a871",
};
